import { render, staticRenderFns } from "./dam-sire-view.vue?vue&type=template&id=5258cdd7&scoped=true&lang=pug"
import script from "./dam-sire-view.js?vue&type=script&lang=js&external"
export * from "./dam-sire-view.js?vue&type=script&lang=js&external"
import style0 from "./dam-sire-view.vue?vue&type=style&index=0&id=5258cdd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5258cdd7",
  null
  
)

export default component.exports